module.exports = __webpack_public_path__ + "img/Lot4.c85d0ccb.jpg";